import React from 'react'
import i18n from 'i18next'
import { observer } from 'mobx-react'
import { Draggable, Droppable } from 'react-beautiful-dnd'

import Typography from '../../UniformComponents/Typography'
import Select from '../form/Select'
import Input from '../form/Input'
import Button from '../../UniformComponents/Button'
import DraggableQuestion from './DraggableQuestion'

const QuestionsControls = ({ store }) => {
    const {
        filteredQuestions, getTitle, handleSearch, surveyOptions, handleSelectSurvey, survey, questions, search, activeSlide
    } = store

    const renderQuestions = () => {
        if (!filteredQuestions || !filteredQuestions.length) {
            return (
                <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', height: '40%', width: '100%' }}>
                    <Typography type="tiny">{`No questions match "${search}".`}</Typography>
                </div>
            )
        }

        return filteredQuestions
            .map(({ pageQuestionId, question }, index) => (
                <Draggable
                    key={pageQuestionId}
                    draggableId={pageQuestionId}
                    index={index}
                    id={pageQuestionId}
                >
                    {(provided) => (
                        <div
                            ref={provided.innerRef}
                            {...provided.draggableProps}
                            {...provided.dragHandleProps}
                        >
                            <DraggableQuestion
                                question={question}
                                getTitle={getTitle}
                                activeSlide={activeSlide}
                                surveyId={survey?.surveyId}
                            />
                        </div>
                    )}
                </Draggable>
            ))
    }

    return (
        <div style={{ height: '100%', display: 'flex', flexDirection: 'column', gap: 20 }}>
            <Select
                label={i18n.t('breadcrumb_Survey')}
                options={surveyOptions}
                onBlur={handleSelectSurvey}
                value={survey?.surveyId || null}
            />

            {survey ? (
                <div>
                    <Input
                        label={i18n.t('search')}
                        onChange={handleSearch}
                        placeholder="Search questions"
                    />

                    <div style={{ marginTop: 20, display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end' }}>
                        <Typography type="tiny">
                            {search
                                ? `${filteredQuestions.length} of ${questions.length} - drag to add`
                                : `${questions.length} question${questions.length !== 0 ? 's' : ''} - drag to add`}
                        </Typography>

                        <Button
                            label="Add all"
                            icon="far fa-plus"
                            onClick={store.handleAddAllQuestions}
                            cssClass="regular tertiary"
                        />
                    </div>
                </div>
            ) : (
                <Typography type="tiny">{i18n.t('powerpoint.noSurveyExplainer')}</Typography>
            )}

            <hr />

            <Droppable droppableId="pp-qlist">
                {(provided) => (
                    <div
                        ref={provided.innerRef}
                        {...provided.droppableProps}
                        className="questionPanel"
                    >
                        {renderQuestions()}
                    </div>
                )}
            </Droppable>
        </div>
    )
}

export default observer(QuestionsControls)
